/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './family-history.reducer';

export const FamilyHistoryDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const familyHistoryEntity = useAppSelector(state => state.familyHistory.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="familyHistoryDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.familyHistory.detail.title">FamilyHistory</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.familyHistory.id">Id</Translate>
            </span>
          </dt>
          <dd>{familyHistoryEntity.id}</dd>
          <dt>
            <span id="relationShip">
              <Translate contentKey="tinyMedicRestApp.familyHistory.relationShip">Relation Ship</Translate>
            </span>
          </dt>
          <dd>{familyHistoryEntity.relationShip}</dd>
          <dt>
            <span id="currAge">
              <Translate contentKey="tinyMedicRestApp.familyHistory.currAge">Curr Age</Translate>
            </span>
          </dt>
          <dd>{familyHistoryEntity.currAge}</dd>
          <dt>
            <span id="ageOfDeath">
              <Translate contentKey="tinyMedicRestApp.familyHistory.ageOfDeath">Age Of Death</Translate>
            </span>
          </dt>
          <dd>{familyHistoryEntity.ageOfDeath}</dd>
          <dt>
            <span id="medicalProblems">
              <Translate contentKey="tinyMedicRestApp.familyHistory.medicalProblems">Medical Problems</Translate>
            </span>
          </dt>
          <dd>{familyHistoryEntity.medicalProblems}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.familyHistory.active">Active</Translate>
            </span>
          </dt>
          <dd>{familyHistoryEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="draft">
              <Translate contentKey="tinyMedicRestApp.familyHistory.draft">Draft</Translate>
            </span>
          </dt>
          <dd>{familyHistoryEntity.draft ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.familyHistory.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{familyHistoryEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.familyHistory.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{familyHistoryEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.familyHistory.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{familyHistoryEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.familyHistory.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{familyHistoryEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.familyHistory.patient">Patient</Translate>
          </dt>
          <dd>{familyHistoryEntity.patient ? familyHistoryEntity.patient.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.familyHistory.relative">Relative</Translate>
          </dt>
          <dd>{familyHistoryEntity.relative ? familyHistoryEntity.relative.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/family-history" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/family-history/${familyHistoryEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default FamilyHistoryDetail;
